import type {
  DxReportViewTest,
  LabFacility,
} from "../../network/useDxReportView";

export const useLabLocations = (labTests: DxReportViewTest[]) => {
  const allLocations = labTests
    .flatMap((test) =>
      test.testResults.map((result) => result.performingLabFacility),
    )
    .filter(Boolean);

  // Lab locations may not have identifiers, so use name and address as a key
  const labLocationKey = (labLocation: LabFacility) =>
    `${labLocation.facilityContactName}${JSON.stringify(labLocation.address)}`;

  const locationsByKey = allLocations.reduce(
    (acc, location) => {
      const key = labLocationKey(location);
      acc[key] = location;
      return acc;
    },
    {} as Record<string, LabFacility>,
  );

  const labValues = Object.freeze(Object.values(locationsByKey));
  const labIndexByKey = labValues.reduce(
    (acc, lab, index) => {
      acc[labLocationKey(lab)] = index;
      return acc;
    },
    {} as Record<string, number>,
  );

  const getLabLocationIndex = (location: LabFacility) =>
    labIndexByKey[labLocationKey(location)];
  return {
    allLabLocations: labValues,
    getLabLocationIndex,
  };
};
